import React from 'react';
import useSWR from 'swr';
// import Link from 'next/link';
import {Box, Grid, Button, Container, Typography} from "@material-ui/core";
import {makeStyles} from '@material-ui/core/styles';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';

import AerialGolfHole from "@/components/03_organisms/AerialGolfHole/AerialGolfHole";
import NoSidebarLayout from "../PageLayouts/NoSidebarLayout";
import Breadcrumbs from "@/components/01_atoms/Breadcrumbs";
import {composeSliderMedia} from "@/utils/transforms";
import dynamic from "next/dynamic";
import {fetchAPIRequestDataSWR, parseParagraphReact} from "@/api/global";

const DynamicGolfCarousel = dynamic(() => import('@/components/03_organisms/CourseCarousel/CourseCarousel'));
const DynamicHoleSummary = dynamic(() => import('@/components/02_molecules/CourseOverlay/CourseOverlay'));

const useStyles = makeStyles((theme) => ({
    topGridStyles: {
      display: 'flex',
      paddingTop: 15
    },
    holeNumberStyles: {
      fontWeight: 'bold',
    },
    topButtonGridStyles: {
      display: 'flex',
      justifyContent: 'flex-end',
    },
    topButtonStyles: {
      '&:hover': {
        backgroundColor: 'transparent !important',
        '& svg': {
          baclgroundColor: 'rgba(0, 0, 0, 0.04)'
        }
      }
    },
    topButtonPrevStyles: {
      border: '1px solid #ddd',
      borderRadius: '5px 0 0 5px',
      marginRight: '5px',
      width: '1.25em',
      height: '1.25em',
      padding: 6,
    },
    topButtonNextStyles: {
      border: '1px solid #ddd',
      borderRadius: '0 5px 5px 0',
      marginLeft: '5px',
      width: '1.25em',
      height: '1.25em',
      padding: 6,
    },
    topPrevStyles: {
      fontWeight: 'bold',
      fontSize: '14px !important',
      color: '#3C8047 !important',
      textDecoration: 'none'
    },
    topNextStyles: {
      fontWeight: 'bold',
      fontSize: '14px !important',
      color: '#3C8047 !important',
      textDecoration: 'none'
    },
    table: {
      minWidth: 650,
    },
  }));
let layoutOpts = {
  titleBgWide: false,
  titleBgClr: "warning.dark",
  mainBgClr: "",
  // mainBgImg: '/images/bg-c-n-page.jpg',
  sideBgClr: false,
  topBgClr: false,
};

function ordinal(n) {
  var s = ["th", "st", "nd", "rd"];
  var v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

function HolePager(props) {
  let {holenum, course} = props;
  let data, error;
  const classes = useStyles();

  let golfHolesQuery = {
    'fields[golf]': 'id,internalId,path,title,holeNum',
    'sort': 'holeNum',
    'filter[isPublished][value]': 1,
    'filter[course.meta.drupal_internal__target_id]': course,
    'filter[hs][condition][operator]': 'IN',
    'filter[hs][condition][path]': 'holeNum',
  };

  if (holenum && golfHolesQuery) {
    golfHolesQuery['filter[hs][condition][value][1]'] = holenum + 1;
    golfHolesQuery['filter[hs][condition][value][2]'] = holenum - 1;

    ({data, error} = useSWR([`/golf`, golfHolesQuery, {type: 'api'}], fetchAPIRequestDataSWR, {}));
  }
  else {
    return 'pager issue';
  }

  return (
    <Grid className={classes.topGridStyles} container>
      <Grid item xs={6}>
        {holenum &&
          <Typography className={classes.holeNumberStyles} variant='h5'>
            {ordinal(holenum)} Hole
          </Typography>
        }
      </Grid>
      <Grid item xs={6} className={classes.topButtonGridStyles}>
        {data?.page_data && data.page_data.map((val, i) => {
          if (val?.holeNum && parseInt(val.holeNum) < parseInt(holenum)) {
            return (
              <Button className={classes.topButtonStyles} key={`prev-btn`} href={val.alias || '#'} title={`Previous hole`}>
                <ArrowBackIcon className={classes.topButtonPrevStyles}
                               color='primary'/>
                <Typography className={classes.topPrevStyles} variant='body2'
                            color='primary'>
                              Previous Hole
                  {/*<Link className={classes.topPrevStyles} color='primary' underline='none' component='a' href={val.alias || '#'} title={`Previous hole`}>
                    Previous Hole
            </Link>*/}
                </Typography>
              </Button>
            );
          }
          if (val?.holeNum && parseInt(val.holeNum) > parseInt(holenum)) {
            return (
              <Button className={classes.topButtonStyles} key={`next-btn`} href={val.alias || '#'} title={`Next hole`}>
                <Typography className={classes.topNextStyles} variant='body2'
                            color='primary'>
                              Next Hole
                 {/*} <Link className={classes.topNextStyles} color='primary' underline='none' component='a' href={val.alias || '#'} title={`Next hole`}>
                    Next Hole
            </Link>*/}
                </Typography>
                <ArrowForwardIcon className={classes.topButtonNextStyles}
                                  color='primary'/>
              </Button>
            );
          }
        })
        }
      </Grid>
    </Grid>
  );
}

export default function CoursePage(props) {
  const classes = useStyles();
  const {node} = props;

  let {title, hideTitle, summary, holeNum, courseTerm, ttlYards, holePar, golfWidth, golfDepth,
    video, body, paraTop, imgAlt, imageOrig, imgTitle, image_styles,
  } = node;

  let slides = null;
  if (node?.slides && node?.slides?.length > 0 && node.slides[0].src !== undefined) {
    slides = node.slides;
  }
  else if (node?.slides && node?.slides?.length > 0) {
    slides = composeSliderMedia(node?.slides);
  }

  const topbar = (
    <>
      {paraTop?.length > 0 &&
      <Typography paragraph component={`div`} className={`region-top`}>
        {
          paraTop.map((para_ent, key) => {
            return parseParagraphReact(key, para_ent, slides);
          })
        }
      </Typography>
      }
      {Array.isArray(node?.breadcrumbs) && node?.breadcrumbs?.length > 0 &&
      <Breadcrumbs links={node.breadcrumbs} />
      }
    </>
  );

  return (
    <NoSidebarLayout title={title} hideTitle={hideTitle} summary={summary}
                     top_region={topbar} opts={layoutOpts}>
      {!node &&
      <Typography component={`p`}>
        Hmm... We couldn't load this page. We will look into it.
      </Typography>
      }
      {node &&
      <Box>
        {/*{holeNum &&*/}
          <HolePager holenum={holeNum} course={courseTerm?.internalId}/>
        {/*}*/}
        {/*{slides?.length > 0 &&*/}
          <DynamicGolfCarousel overlayData={{title, body, ttlYards, holePar, golfWidth, golfDepth}} slides={slides}/>
        {/*}*/}
        { (!slides || slides?.length < 1 ) &&
          <DynamicHoleSummary inline={true} node={{title, body, ttlYards, holePar, golfWidth, golfDepth}} />
        }
        {/*{yardage?.length > 0 &&
          <YardageTable data={yardage} />
        }*/}
        <AerialGolfHole
          ytSource= {video?.videoEmbed || video?.videoFile}
          imgSource={image_styles?.max_1200_width?.href || imageOrig}
        />
      </Box>
      }
    </NoSidebarLayout>
  );
}
